export default function Footer() {
  return (
    <footer className="bg-[#0F1F2E] text-white py-16 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="/assets/senteo-corp/img/service/SENTEO_tag.png" 
              alt="ロゴ" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              従業員のメンタルヘルスを守り、<br />
              企業の持続的な成長を支援します
            </p>
          </div>

          {/* Site Info */}
          <div>
            <h3 className="text-base font-bold mb-4">サイト情報</h3>
            <ul className="space-y-3">
              <li>
                <a href="#top" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  トップ
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  サービス内容
                </a>
              </li>
              <li>
                <a href="#benefits" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  導入メリット
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  よくある質問
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-base font-bold mb-4">法的情報</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://www.senteo.co.jp" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors inline-flex items-center gap-2 cursor-pointer">
                  <span>会社情報</span>
                  <i className="ri-external-link-line text-xs"></i>
                </a>
              </li>
              <li>
                <a href="https://www.senteo.co.jp/privacy" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors inline-flex items-center gap-2 cursor-pointer">
                  <span>プライバシーポリシー</span>
                  <i className="ri-external-link-line text-xs"></i>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base font-bold mb-4">お問い合わせ</h3>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              サービスに関するご質問は<br />
              お問い合わせフォームより<br />
              お気軽にご連絡ください
            </p>
            <a 
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=YKcf0P9g2U-Our9eD2Xtbv5ca4bq0tFEuCs_nTfkrFhUN0Y5NDJKVjZYM0tWSU5CMVU3TkZWTEM3VS4u"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#4A7BA7] text-white text-sm rounded-lg hover:bg-[#3A6B97] transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>お問い合わせ</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              &copy; SENTEO ALL Rights Reserved.
            </p>
          </div>
        </div>
      </div>

      {/* Background Brand Text */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
        <p className="text-[#1A3B5C] text-8xl font-bold opacity-10 text-center whitespace-nowrap overflow-hidden">
          MENTAL HEALTH SUPPORT
        </p>
      </div>
    </footer>
  );
}
